module.exports = __webpack_public_path__ + "static/media/image_slate@2x-min.59981fa8.jpg";